var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1626_12213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09586 15.4422C4.09525 17.4587 4.62216 19.4276 5.62399 21.163L4 27.0926L10.0681 25.5015C11.7398 26.4127 13.6222 26.8936 15.5378 26.8941H15.5429C21.8513 26.8941 26.9865 21.7607 26.9891 15.4513C26.9903 12.3938 25.8007 9.51885 23.6395 7.3559C21.4786 5.19307 18.6046 4.00133 15.5424 4C9.23334 4 4.09851 9.13302 4.09586 15.4422Z",
    fill: "url(#paint0_linear_1626_12213)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68724 15.4385C3.68652 17.5275 4.23235 19.5669 5.26988 21.3644L3.58765 27.5065L9.87334 25.8584C11.6052 26.8027 13.5552 27.3005 15.5394 27.3013H15.5445C22.0792 27.3013 27.3988 21.9833 27.4016 15.448C27.4027 12.2807 26.1703 9.30241 23.9319 7.06193C21.6931 4.82169 18.7163 3.58714 15.5445 3.58582C9.00859 3.58582 3.68989 8.90295 3.68724 15.4385ZM7.43042 21.0549L7.19578 20.6823C6.20914 19.1135 5.68838 17.3007 5.68911 15.4392C5.69128 10.0072 10.1121 5.5878 15.5482 5.5878C18.1807 5.58889 20.6548 6.61508 22.5156 8.47709C24.3764 10.3392 25.4003 12.8146 25.3996 15.4473C25.3972 20.8794 20.9763 25.2994 15.5445 25.2994H15.5406C13.7719 25.2984 12.0374 24.8235 10.5246 23.9259L10.1645 23.7124L6.43449 24.6904L7.43042 21.0549Z",
    fill: "url(#paint1_linear_1626_12213)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.581 10.4833C12.359 9.98993 12.1255 9.98004 11.9143 9.97136C11.7416 9.96401 11.5439 9.96448 11.3466 9.96448C11.149 9.96448 10.828 10.0388 10.5566 10.3351C10.2849 10.6316 9.51953 11.3483 9.51953 12.8059C9.51953 14.2636 10.5813 15.6722 10.7292 15.87C10.8774 16.0675 12.7789 19.1544 15.7902 20.3419C18.2929 21.3288 18.8022 21.1325 19.3454 21.0831C19.8885 21.0338 21.0982 20.3667 21.3451 19.6748C21.592 18.9831 21.592 18.3901 21.518 18.2663C21.4439 18.1428 21.2463 18.0687 20.9501 17.9206C20.6537 17.7724 19.1972 17.0556 18.9256 16.9567C18.654 16.858 18.4565 16.8087 18.2589 17.1053C18.0614 17.4015 17.494 18.0687 17.3211 18.2663C17.1483 18.4643 16.9754 18.489 16.6791 18.3408C16.3828 18.1921 15.4286 17.8796 14.2966 16.8704C13.4158 16.0851 12.8213 15.1154 12.6484 14.8187C12.4756 14.5225 12.6299 14.362 12.7785 14.2143C12.9116 14.0816 13.0749 13.8684 13.223 13.6955C13.3709 13.5225 13.4202 13.399 13.5189 13.2014C13.6178 13.0036 13.5684 12.8306 13.4943 12.6824C13.4202 12.5343 12.8444 11.0692 12.581 10.4833Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1626_12213",
    x: 0,
    y: 0,
    width: 30.989,
    height: 31.0925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1626_12213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1626_12213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1626_12213",
    x1: 15.4946,
    y1: 27.0926,
    x2: 15.4946,
    y2: 4.00001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1626_12213",
    x1: 15.4946,
    y1: 27.5065,
    x2: 15.4946,
    y2: 3.58578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.83087da6c5081f7ee2a9f3086b904bfc.svg";
export { ForwardRef as ReactComponent };